import { TreeNode } from "../lib/tree-node";
import { Grid } from "../../graph/lib/grid";
import { Node } from "../../graph/lib/node";
import { WordTreeFixedSize } from "./word-tree-fixed-size";

//Deprecated
export class WordTreeNode extends TreeNode {

    fixedSize: boolean = false;

    constructor(rowIndex: number, colIndex: number, id: number, parent: TreeNode,
        words: string[], alphabet: string[], depth: number) {
        super(rowIndex, colIndex, id, parent, words, alphabet, depth);
    }

    draw(ctx: CanvasRenderingContext2D, grid: Grid) {

        let center: [number, number] = grid.getCellCenter(this.rowIndex, this.colIndex);
        ctx.save();
        this.drawBoxes(ctx, grid);
        // ctx.fillText(text, center[0], center[1], standardWidth);
        if (!this.isHidden())
            this.drawContent(ctx, grid);
        ctx.stroke();
        ctx.fill();
        ctx.restore();
    }

    private drawBoxes(ctx: CanvasRenderingContext2D, grid: Grid) {
        let topLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        ctx.save();
        let boxheight: number = this.boxHeight(grid);
        let offsetHeight: number = this.boxOffSetHeight(grid);
        let boxWidth: number = this.boxWidth(grid);

        for (let i = 0; i < this.depth; i++) {
            ctx.strokeRect(topLeft[0] + (boxWidth * i), topLeft[1] + offsetHeight, boxWidth, boxheight);
            ctx.stroke();
        }


        ctx.restore();
    }

    private boxOffSetHeight(grid: Grid): number {
        return this.boxHeight(grid) / 2;
    }

    private boxWidth(grid: Grid): number {
        let width: number = grid.getWidthCell() / this.depth;
        return width;
    }

    private boxHeight(grid: Grid): number {
        let boxheight: number = grid.getHeightCell() / 2;
        return boxheight;
    }

    private drawContent(ctx: CanvasRenderingContext2D, grid: Grid) {
        let topLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        ctx.save();
        let boxheight: number = this.boxHeight(grid);
        let offsetHeight: number = this.boxOffSetHeight(grid);
        let boxWidth: number = this.boxWidth(grid);
        let standardWidth = 55;
        let textSize = 25;


        let midY: number = (topLeft[1] + offsetHeight + 1 * boxheight / 2 + textSize / 2)

        for (let i = 0; i < this.content.length; i++) {
            let midX: number = (topLeft[0] + boxWidth * (i) + boxWidth / 2);

            ctx.textAlign = "center";

            ctx.font = 'bold ' + textSize + 'px Arial';
            ctx.fillStyle = this.currentColor;
            ctx.fillText(this.content[i], midX, midY, boxWidth - 2);
            ctx.fill();
        }
        ctx.restore();
        let size = 5;

    }

    inParameter(e: MouseEvent, grid: Grid): boolean {
        const upperCornerLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        const x: number = upperCornerLeft[0];
        const y: number = upperCornerLeft[1];

        const width: number = grid.getWidthCell();
        const boxheight: number = grid.getHeightCell();

        let xInRange: boolean = (x <= e.offsetX && e.offsetX <= x + width)
        
        let yInRange: boolean = (y <= e.offsetY && e.offsetY <= y + boxheight);
        //console.log("Node: " + this.getContent());
        //console.log("X: " + x + ". e.offsetX: " + e.offsetX +". width: " + width);

        return (xInRange && yInRange);

    }

    setFixedSize(fs: boolean) {
        this.fixedSize = fs;
    }

    getStandardWidth(grid: Grid): number {

        let standardWidth = Math.max(grid.getWidthCell() * 1.5,
            grid.getWidthCell() + 1 * (this.textMaxWidthCol * grid.getWidthCell()) / 4);

        if (this.parent == null) {
            standardWidth = grid.getWidthCell();
        }

        if (this.fixedSize) {
            standardWidth = grid.getWidthCell();
        }

        return standardWidth;

    }

    getTextSize(grid: Grid): number {
        let textSize = 3 * (grid.getHeightCell() / 5);
        if (this.fixedSize) {
            textSize = grid.getHeightCell();
        }
        return textSize;
    }


    clone(): Node {
        let cloneNode: WordTreeNode = new WordTreeNode(this.rowIndex, this.colIndex, this.id, this.parent, this.content, this.alphabet, this.depth);
        return cloneNode;
    }

}
